import React, { useState } from 'react';
import { OverlayTrigger, Popover, Button } from "react-bootstrap";
import {Tooltip} from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

const UpgradeButton = ({ onUpgrade }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleToggle = () => {
        setIsOpen(false);
    };

    const handleClick = () => {
        setIsOpen(prev => !prev)
    }

    return (
        <OverlayTrigger
            trigger="click"
            rootClose
            rootCloseEvent="click"
            placement='bottom'
            show={isOpen}
            onToggle={handleToggle}
            overlay={
                <Popover id="pattern-game-description">
                    <Popover.Content className={"upgrade-popup-style"}>
                        Are you sure you want to upgrade this game? Doing so will delete this secondary game and convert it into an example game.
                        <div>
                        <Button
                            onClick={() => {
                                onUpgrade();
                                setIsOpen(false); // Close popover after deletion
                            }}
                            size="sm"
                            className="upgrade-confirm-button"
                        >
                            Upgrade
                        </Button>
                        </div>
                    </Popover.Content>
                </Popover>
            }
        >
            <Tooltip title="Upgrade to an Example Game" placement="top">
                <AddCircleOutlineIcon
                    onClick={handleClick}
                    className="upgrade-example-games-button"
                />
            </Tooltip>
        </OverlayTrigger>
    );
};

export default UpgradeButton;
